import React from 'react';
import { cn } from '@/utils/cn';
import { storeLocatorSearchTypes } from '@/constants/types';
import Icon from '../Icon';
import ButtonLabel from '../Typography/ButtonLabel';

function DirectionOnMapButton({
  item,
  type = storeLocatorSearchTypes.default,
  isDetails = false,
}) {
  const handleLinkClick = (event) => {
    event.stopPropagation();
  };

  return (
    <a
      href={item?.hrefUrl}
      target="_blank"
      className={cn('direction-on-map-button', {
        'w-full h-[28px] lg:h-[36px] bg-tealgreen flex justify-center items-center gap-[8px] lg:gap-[8px] !px-16 lg:!px-16 !py-6 lg:!py-8 border-tealgreen rounded-full hover:bg-cape-verde border border-transparent':
          type === storeLocatorSearchTypes.default,
        'hover:scale-125 hidden lg:block':
          type === storeLocatorSearchTypes.inStorePickup,
        'hover:scale-125 block hover:cursor-pointer':
          type === storeLocatorSearchTypes.inStorePickup && isDetails,
      })}
      rel="noreferrer"
      onClick={handleLinkClick}
    >
      <Icon
        type="book-stack"
        className={cn('size-[16px] lg:size-[24px]', {
          'size-[24px]':
            type === storeLocatorSearchTypes.inStorePickup && isDetails,
        })}
        color={
          type === storeLocatorSearchTypes.inStorePickup ? '#00685F' : 'white'
        }
      />

      {type === storeLocatorSearchTypes.default ? (
        <ButtonLabel
          label="Direction on Map"
          className="text-xs lg:text-sm text-white font-semibold lg:font-bold line-clamp-1"
        />
      ) : null}
    </a>
  );
}

export default DirectionOnMapButton;
